import { z } from "zod";
import { AgencyIdSchema, ProjectIdSchema } from "../primitives/ids.js";
/** PF-006 — client binary upload boundary (fail-closed; no live storage pipeline). */
export const CLIENT_BINARY_UPLOAD_MAX_BYTES = 10 * 1024 * 1024;
export const CLIENT_BINARY_ALLOWED_MIME_TYPES = [
    "image/jpeg",
    "image/png",
    "image/webp",
    "application/pdf",
];
export const ClientBinaryAllowedMimeSchema = z.enum(CLIENT_BINARY_ALLOWED_MIME_TYPES);
export const ClientBinaryUploadRequestV1Schema = z
    .object({
    schemaVersion: z.literal("client-binary-upload.v1.0"),
    agencyId: AgencyIdSchema,
    projectId: ProjectIdSchema,
    clientLinkId: z.string().min(1),
    mimeType: z.string().min(1),
    byteLength: z.number().int().positive(),
    sha256Hex: z
        .string()
        .regex(/^[a-f0-9]{64}$/i, "sha256Hex must be 64 hex chars"),
    rightsStatus: z.string().optional(),
    filename: z.string().max(255).optional(),
})
    .strict();
export const ClientBinaryUploadDecisionV1Schema = z
    .object({
    schemaVersion: z.literal("client-binary-upload-decision.v1.0"),
    allowed: z.boolean(),
    reason: z.enum([
        "allowed",
        "mime_denied",
        "size_denied",
        "tenant_denied",
        "client_link_denied",
        "rights_required",
        "malware_infected",
        "malware_scan_required",
    ]),
})
    .strict();
//# sourceMappingURL=client-binary-upload.js.map